export default [
    {
      path: '/mutasi_masuk',
      name: 'mutasi_masuk',
      component: () => import('@/views/mutasi_masuk/MutasiMasuk.vue'),
      meta: {
        pageTitle: 'Mutasi Masuk',
        breadcrumb: [
          {
            text: 'Mutasi Masuk',
            active: true,
          },
        ],
        middleware: 'Auth',
      },
    },
  ]
  